<div class="course-registration-container">
  <div class="header">
    <h1>HKIE CPD Course Registration</h1>
    <p class="subtitle">Select a course below to proceed with registration</p>
  </div>

  <div class="courses-grid">
    <div class="course-card" *ngFor="let course of courses">
      <h1 style="text-align: center">{{ course.ref_no }}</h1>
      <h2>{{ course.title }}</h2>
      <p style="text-align: justify; white-space: pre-line">{{ course.description }}</p>

      <button class="toggle-sessions" (click)="toggleSessions(course)">
        {{
          course.showSessions
            ? "Hide Available Sessions"
            : "Show Available Sessions"
        }}
      </button>

      <!-- Mobile view: Session cards -->
      <div
        class="sessions-cards"
        [class.sessions-visible]="course.showSessions"
      >
        <h3>Available Sessions</h3>
        <div class="session-card" *ngFor="let session of course.sessions">
          <div class="session-detail">
            <span class="detail-label">Month:</span>
            <span class="detail-value">{{ session.month }}</span>
          </div>
          <div class="session-detail">
            <span class="detail-label">Date:</span>
            <span class="detail-value">{{ session.date }}</span>
          </div>
          <div class="session-detail">
            <span class="detail-label">Time:</span>
            <span class="detail-value">{{ session.time }}</span>
          </div>
          <div class="session-detail">
            <span class="detail-label">Code:</span>
            <span class="detail-value">{{ session.code }}</span>
          </div>
          <div class="session-detail">
            <span class="detail-label">Fee:</span>
            <span class="detail-value">{{ session.fee }}</span>
          </div>
        </div>
      </div>

      <!-- Desktop view: Table -->
      <div class="sessions-table">
        <h3>Available Sessions</h3>
        <table>
          <thead>
            <tr>
              <th>Month</th>
              <th>Date</th>
              <th>Time</th>
              <th>Code</th>
              <th>Fee</th>
            </tr> 
          </thead>
          <tbody>
            <tr *ngFor="let session of course.sessions">
              <td>{{ session.month }}</td>
              <td>{{ session.date }}</td>
              <td>{{ session.time }}</td>
              <td>{{ session.code }}</td>
              <td>{{ session.fee }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style="text-align: right;"> Registration Deadline is the 1st of the respective month. </p>

      <a [href]="course.formLink" target="_blank" class="register-button">
        Register Now
      </a>
    </div>
  </div>
</div>
